import { FC, PropsWithChildren } from 'react'
import { HeaderProps } from 'react-table'
import { useListView } from '../../../../app/pages/ListUsers/users-list/core/ListViewProvider'
// import {User} from '../../core/_models'

type Props = {
  tableProps: PropsWithChildren<HeaderProps<IUsers>>
}

const UserSelectionHeader: FC<Props> = ({ tableProps }) => {
  const { isAllSelected, onSelectAll } = useListView()
  return (
    <th {...tableProps.column.getHeaderProps()} className='w-10px'>
      <div className='form-check form-check-sm form-check-custom form-check-solid'>
        <input
          className='form-check-input'
          type='checkbox'
          data-kt-check={isAllSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isAllSelected}
          onChange={onSelectAll}
        />
      </div>
    </th>
  )
}

export { UserSelectionHeader }
